export default __webpack_public_path__ + "locales/az/DowngradePlanDialog.json?hash=55b0d5a3408b68772230d2a8d5ced20b";